"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityOrientationDto = instanceOfFacilityOrientationDto;
exports.FacilityOrientationDtoFromJSON = FacilityOrientationDtoFromJSON;
exports.FacilityOrientationDtoFromJSONTyped = FacilityOrientationDtoFromJSONTyped;
exports.FacilityOrientationDtoToJSON = FacilityOrientationDtoToJSON;
exports.FacilityOrientationDtoToJSONTyped = FacilityOrientationDtoToJSONTyped;
const SpecialtyAbbrDto_1 = require("./SpecialtyAbbrDto");
const StipendDto_1 = require("./StipendDto");
const ProfileNameDto_1 = require("./ProfileNameDto");
const OrientationCancellationInfoDto_1 = require("./OrientationCancellationInfoDto");
const FacilityDto_1 = require("./FacilityDto");
const OrientationStatus_1 = require("./OrientationStatus");
const LicenseType_1 = require("./LicenseType");
const OrientationSessionDto_1 = require("./OrientationSessionDto");
/**
 * Check if a given object implements the FacilityOrientationDto interface.
 */
function instanceOfFacilityOrientationDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    if (!('payRate' in value) || value['payRate'] === undefined)
        return false;
    if (!('totalRate' in value) || value['totalRate'] === undefined)
        return false;
    if (!('orientationSessions' in value) || value['orientationSessions'] === undefined)
        return false;
    if (!('totalSeats' in value) || value['totalSeats'] === undefined)
        return false;
    if (!('openSeats' in value) || value['openSeats'] === undefined)
        return false;
    if (!('facility' in value) || value['facility'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('lastEditedAt' in value) || value['lastEditedAt'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('postedBy' in value) || value['postedBy'] === undefined)
        return false;
    if (!('cancellation' in value) || value['cancellation'] === undefined)
        return false;
    if (!('lastEditedByProfile' in value) || value['lastEditedByProfile'] === undefined)
        return false;
    return true;
}
function FacilityOrientationDtoFromJSON(json) {
    return FacilityOrientationDtoFromJSONTyped(json, false);
}
function FacilityOrientationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'licenseType': (0, LicenseType_1.LicenseTypeFromJSON)(json['licenseType']),
        'description': json['description'] == null ? undefined : json['description'],
        'payRate': json['payRate'],
        'totalRate': json['totalRate'],
        'orientationSessions': (json['orientationSessions'].map(OrientationSessionDto_1.OrientationSessionDtoFromJSON)),
        'totalSeats': json['totalSeats'],
        'openSeats': json['openSeats'],
        'facility': (0, FacilityDto_1.FacilityDtoFromJSON)(json['facility']),
        'status': (0, OrientationStatus_1.OrientationStatusFromJSON)(json['status']),
        'specialty': json['specialty'] == null ? undefined : (0, SpecialtyAbbrDto_1.SpecialtyAbbrDtoFromJSON)(json['specialty']),
        'lastEditedAt': (new Date(json['lastEditedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'stipends': json['stipends'] == null ? undefined : (json['stipends'].map(StipendDto_1.StipendDtoFromJSON)),
        'stipendMinimumDistance': json['stipendMinimumDistance'] == null ? undefined : json['stipendMinimumDistance'],
        'isSearchable': json['isSearchable'] == null ? undefined : json['isSearchable'],
        'postedBy': json['postedBy'],
        'cancellation': (0, OrientationCancellationInfoDto_1.OrientationCancellationInfoDtoFromJSON)(json['cancellation']),
        'lastEditedByProfile': (0, ProfileNameDto_1.ProfileNameDtoFromJSON)(json['lastEditedByProfile']),
    };
}
function FacilityOrientationDtoToJSON(json) {
    return FacilityOrientationDtoToJSONTyped(json, false);
}
function FacilityOrientationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'licenseType': (0, LicenseType_1.LicenseTypeToJSON)(value['licenseType']),
        'description': value['description'],
        'payRate': value['payRate'],
        'totalRate': value['totalRate'],
        'orientationSessions': (value['orientationSessions'].map(OrientationSessionDto_1.OrientationSessionDtoToJSON)),
        'totalSeats': value['totalSeats'],
        'openSeats': value['openSeats'],
        'facility': (0, FacilityDto_1.FacilityDtoToJSON)(value['facility']),
        'status': (0, OrientationStatus_1.OrientationStatusToJSON)(value['status']),
        'specialty': (0, SpecialtyAbbrDto_1.SpecialtyAbbrDtoToJSON)(value['specialty']),
        'lastEditedAt': ((value['lastEditedAt']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'stipends': value['stipends'] == null ? undefined : (value['stipends'].map(StipendDto_1.StipendDtoToJSON)),
        'stipendMinimumDistance': value['stipendMinimumDistance'],
        'isSearchable': value['isSearchable'],
        'postedBy': value['postedBy'],
        'cancellation': (0, OrientationCancellationInfoDto_1.OrientationCancellationInfoDtoToJSON)(value['cancellation']),
        'lastEditedByProfile': (0, ProfileNameDto_1.ProfileNameDtoToJSON)(value['lastEditedByProfile']),
    };
}
//# sourceMappingURL=FacilityOrientationDto.js.map